import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import Footer from '../components/Footer';
import Header from '../components/Header/Header';

const PageContainer = () => {
  const location = useLocation();
  const [toggle, setToggle] = useState(false);
  const { i18n } = useTranslation();

  useEffect(() => {
    // Scroll to top unless the pathname starts with 'basin-odasi'
    if (!location.pathname.startsWith('/basin-odasi')) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  const pageVariants = {
    initial: { translateY: -10, opacity: 0 },
    in: { translateY: 0, opacity: 1 },
    out: { translateY: 10, opacity: 0 },
  };

  const pageTransition = {
    type: 'tween',
    ease: 'easeIn',
    duration: 1,
  };

  // Determine which image to show based on current language
  const getImageSrc = () => {
    return i18n.language === 'en' ? '/images/m-en.svg' : '/images/m-tr.svg';
  };

  return (
    <div className='relative'>
      <Header />
      <div className='relative z-40 bg-white'>
        <motion.div
          key={location.pathname}
          initial='initial'
          animate='in'
          exit='out'
          variants={pageVariants}
          transition={pageTransition}
        >
          <Outlet />
        </motion.div>
      </div>
      <Footer />


      {location.pathname.includes('iletisim') && (
        <a href='https://www.turkuazoneri.com/' target='_blank' className='block bottom-10 right-[11.1%] md:right-10   z-50 fixed hover:scale-105 duration-300 cursor-pointer overflow-hidden'>
          <img src={getImageSrc()} className='w-14 md:w-20 '/>
        </a>
      )}
    </div>
  );
};

export default PageContainer;
